var React = require('react');

function PauseCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z","stroke":"black","strokeWidth":"2","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M13 12V20","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M19 12V20","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

PauseCircle.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = PauseCircle;

PauseCircle.default = PauseCircle;
